'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@newfront-insurance/core-ui/v2';
import { motion } from 'framer-motion';
interface Props {
  show: boolean;
}
export function ThinkingMessage(t0) {
  const $ = _c(2);
  const {
    show
  } = t0;
  if (!show) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex w-full items-center gap-4 rounded-lg", "group-data-[role=user]/message:ml-auto group-data-[role=user]/message:w-fit", "group-data-[role=user]/message:max-w-3xl group-data-[role=user]/message:px-3", "group-data-[role=user]/message:bg-muted group-data-[role=user]/message:py-2");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <motion.div data-testid="message-assistant-loading" className="group/message mx-auto w-full max-w-3xl px-8" data-role="assistant"><div className={t1}><div className="flex items-center gap-2">{[0, 1, 2].map(_temp)}</div></div></motion.div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
function _temp(i) {
  return <motion.div key={i} className="bg-steel-200 size-2 rounded-full" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 0.5
  }} transition={{
    repeat: Infinity,
    repeatType: "reverse",
    duration: 0.8,
    delay: i * 0.2,
    ease: "easeInOut"
  }} />;
}